import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Nearby Business Card {Horizontal}: así aparece el negocio en la lista del mapa de la app. */
@Component({
  selector: 'app-nearby-card',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-card-front class="thumb" [url]="frontUrl()" placeholder="Tu tarjeta" />
    <div class="info">
      <p class="name">{{ name() || 'Tu negocio' }}</p>
      <p class="meta">{{ category() || 'Sin categoría' }}@if (distance()) { · {{ distance() }} }</p>
      <span class="pill"><cr-icon name="gift" [size]="16" />{{ pill() }}</span>
    </div>
    <cr-icon class="chev" name="chevron-right" [size]="24" />
  `,
  styles: [`
    :host{display:flex;align-items:center;gap:16px;padding:12px;border-radius:20px;background:#fff;border:1px solid var(--cr-border-subtle);box-shadow:var(--cr-elevation-2);min-width:0}
    .thumb{width:112px;flex:none;--shadow:var(--cr-elevation-2)}
    .info{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;align-items:flex-start}
    .name{margin:0;font:600 20px/24px var(--cr-font-display);letter-spacing:-.1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}
    .meta{margin:0;font:400 13px/18px var(--cr-font-body);color:var(--cr-text-secondary)}
    .pill{margin-top:6px;display:inline-flex;align-items:center;gap:6px;padding:4px 10px 4px 8px;border-radius:999px;background:var(--cr-brand-teal-soft);color:var(--cr-brand-teal-strong);font:600 13px/18px var(--cr-font-body);white-space:nowrap}
    .chev{color:var(--cr-text-primary)}
    @media (max-width:400px){ .thumb{width:84px} .name{font-size:17px} }
  `],
})
export class NearbyCardComponent {
  readonly name = input<string>('');
  readonly category = input<string | null | undefined>('');
  readonly frontUrl = input<string | null | undefined>(null);
  readonly distance = input<string>('350 m');
  readonly pill = input<string>('Tarjeta por diseñar');
}
